import { query } from '@angular/animations';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ActivatedRoute } from '@angular/router';
import { concatMap, Observable, startWith, takeWhile, map, filter } from 'rxjs';
import { City, Country, State } from 'src/app/models/master-data.model';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';

@Component({
  selector: 'app-brand-filters',
  templateUrl: './brand-filters.component.html',
  styleUrls: ['./brand-filters.component.scss']
})

export class BrandFiltersComponent {
  @Input() data: any[] = [];
  @Output() filteredData = new EventEmitter<any[]>();
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  @ViewChild('searchContainer') searchContainer: ElementRef | undefined;
  paramsSearch: any;
  dataObj : any [] = [];
  filteredObj : any[] = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  showNoRecordsFounds: boolean = true;
  textFromUniversalSearch: string = '';
  filterObject: any;
  countries!: any[];
  allCountriesSymbol: any[] = [];
  states!: any[];
  cities!: any[];
  brands!: any[];
  categories!: any[];
  yearInMarkets!: any[];
  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  brandControl = new FormControl();
  categoryControl = new FormControl();
  currencySymbolControl = new FormControl();
  amountRangeControl = new FormControl();
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  filteredBrands: any[] | undefined;
  filteredCategories: any[] | undefined;
  filterForm: FormGroup = new FormGroup({
    keywords: new FormControl(null),
    countries: new FormControl([]),
    states: new FormControl(null),
    cities: new FormControl(null),
    zipCode: new FormControl(null),
    brands: new FormControl(null),
    yearFrom: new FormControl(0),
    yearTo: new FormControl(0),
    currencySymbol: new FormControl(''),
    amountRange: new FormControl(0),
    categories: new FormControl(null),
  });

  currencySymbol: string = ''


  filterControls = ['keywords', 'countries', 'states', 'cities', 'zipCode', 'brands', 'yearInMarkets', 'currencySymbol', 'amountRange', 'categories'];

  constructor(
    private readonly masterDataService: MasterDataService,
    private oemService : OemService,
    private categoryService: CategoryService,
    private renderer: Renderer2,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute
  ) {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  amountRange: { label: string; min: number; max: number }[] = [
    { label: '0 - 50K', min: 0, max: 50000 },
    { label: '50K - 100K', min: 50001, max: 100000 },
    { label: '100K - 150K', min: 100001, max: 150000 },
    { label: '150K - Other', min: 150001, max: Infinity },
  ];

  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if(autoComplete.panelOpen){
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if(!isScrollingInsidePanel){
      this.closeAllPanels();
    }
  }

  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataObj = this.data;
  }

  ngOnInit(): void {
    this.filterForm.valueChanges.subscribe(() => {
      this.applyFilter();
    });

    this.loadCountries('');
    // this.loadStates();
    // this.loadCities('');
    this.loadBrands();
    this.loadcategories();   
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.paramsSearch = params.get('search') || '';
      this.textFromUniversalSearch = this.paramsSearch ;
      this.searchSuggestion(this.paramsSearch);
      this.paramsSearch ='';
    }) 
    this.countryControl.valueChanges.subscribe(value => {
      if (!value?.countryName) {
        this.filteredCountries = this.countries.filter(country =>
          country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.stateControl.valueChanges.subscribe(value => {
      if (!value?.stateName) {
        this.filteredStates = this.states.filter(state =>
          state.stateName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.cityControl.valueChanges.subscribe(value => {
      if (!value?.cityName) {
        this.filteredCities = this.cities.filter(city =>
          city.cityName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });

    this.brandControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredBrands = this.brands.filter(brand =>
          brand.name.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });

    this.categoryControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredCategories = this.categories.filter(category =>
          category.name.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });

    this.renderer.listen('document', 'click', (event: Event) => {
      const searchElement = this.searchContainer?.nativeElement;

      if (searchElement && !searchElement.contains(event.target)) {
        this.isSugestionOpen = false;
      }
    });
  }

  toggleSuggestions() {
    this.isSugestionOpen = !this.isSugestionOpen;
  }

  applyFilter(): void {

    let filtered = [...this.dataObj]; // Ensure we are working with a fresh copy
    this.filteredStates = [];
    this.filteredCities = [];
  
    const { keywords, countries, states, cities, zipCode, brands, yearFrom, yearTo, categories, amountRange, currencySymbol } = this.filterForm.value;
  
    // If no filters are applied, return the full dataset
    if (
      (!keywords || keywords.length === 0) &&
      (!countries || countries.length === 0) &&
      (!states || states.length === 0) &&
      (!cities || cities.length === 0) &&
      !zipCode &&
      (!brands || brands.length === 0) &&
      (!categories || categories.length === 0) &&
      (!amountRange || amountRange.length === 0) &&
      (!currencySymbol || currencySymbol.length === 0) &&
      !(yearFrom > 0 || yearTo > 0)
    ) {
      this.filteredData.emit(this.dataObj);
      return;
    }
  
    filtered = filtered.filter(item => {
      const lowerCaseKeywords = keywords?.map((keyword: string) => keyword.toLowerCase()) || [];
      const splitCurrencyArray = Array.isArray(currencySymbol) ? currencySymbol.map(symbol => symbol.split(' - ')[0]) : [];
      const selectedCategoryIds = categories?.map((categoryName: string) => {
        const matchedCategory = this.categories.find(category => category?.name?.toLowerCase() === categoryName?.toLowerCase());
        return matchedCategory ? matchedCategory.id : null;
      }).filter((id: null) => id !== null) || [];
  
      // ✅ Fix: Ensures keyword filtering is applied correctly
      const keywordMatch =
        !keywords || keywords.length === 0 ||
        lowerCaseKeywords.some((keyword: any) =>
          (item.name && item.name.toLowerCase().includes(keyword)) ||
          (item.oemName && item.oemName.toLowerCase().includes(keyword)) ||
          (item.country && item.country.toLowerCase().includes(keyword)) ||
          (item.state && item.state.toLowerCase().includes(keyword)) ||
          (item.city && item.city.toLowerCase().includes(keyword))
        );
  
      // OR logic within the same filter category
      const countryMatch = !countries || countries.length === 0 || countries.some((country: string) => item.country?.toLowerCase() === country.toLowerCase());
      const stateMatch = !states || states.length === 0 || states.some((state: string) => item.state?.toLowerCase() === state.toLowerCase());
      const cityMatch = !cities || cities.length === 0 || cities.some((city: string) => item.city?.toLowerCase() === city.toLowerCase());
  
      const zipCodeMatch = !zipCode || String(item.zipCode) === String(zipCode);
  
      const brandMatch =
        !brands || brands.length === 0 ||
        (item.name && brands.some((name: string) => item.name.toLowerCase() === name.toLowerCase())) ||
        (item.oemName && brands.some((name: string) => item.oemName.toLowerCase() === name.toLowerCase()));
  
      const yearMatch =
        !(yearFrom > 0 || yearTo > 0) ||
        (() => {
          const currentYear = new Date().getFullYear();
          const calculatedYearFrom = currentYear - yearFrom;
          const calculatedYearTo = currentYear - yearTo;
          const year = item.year ? parseInt(item.year, 10) : null;
          return year !== null && year >= calculatedYearTo && year <= calculatedYearFrom;
        })();
  
      const currencyMatch =
        !currencySymbol || currencySymbol.length === 0 ||
        (() => {
          const countryArray = this.allCountriesSymbol
            .filter((c: any) => c.currencySymbol && splitCurrencyArray.includes(c.currencySymbol))
            .map((c: any) => c.countryName);
          return item.country && countryArray.includes(item.country);
        })();
  
      const amountRangeMatch =
        !amountRange || amountRange.length === 0 ||
        (() => {
          const turnOver = item.turnOver ? parseFloat(item.turnOver) : null;
          return amountRange.some((range: { min: number; max: number }) => turnOver !== null && turnOver >= range.min && turnOver <= range.max);
        })();
  
      const categoryMatch =
        !categories || categories.length === 0 ||
        (() => {
          return item.productCategories && item.productCategories.some((categoryId: string) => selectedCategoryIds.includes(categoryId));
        })();
  
      return (
        keywordMatch &&
        countryMatch &&
        stateMatch &&
        cityMatch &&
        zipCodeMatch &&
        brandMatch &&
        yearMatch &&
        currencyMatch &&
        amountRangeMatch &&
        categoryMatch
      );
    });
  this.loadStates();
  this.loadCities();
    this.filteredData.emit(filtered);
  }
  
  

  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;
    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCountries = allCountries.concat(response.data);
          this.allCountriesSymbol = allCountries;
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
        this.filteredCountries = allCountries;
      });
  }
  
  
  loadStates() {
    if(!this.filterForm.get('countries')) {
      return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allStates: any[] = [];
    let morePages = true;
    this.masterDataService.getStates(pageNumber, pageSize, '', [this.filterForm.get('countries')?.value])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', [this.filterForm.get('countries')?.value]);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }

  loadCities() {
    if(!this.filterForm.get('states')) {
      return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allCities: any[] = [];
    let morePages = true;
    this.masterDataService.getCities(pageNumber, pageSize, '', this.filterForm.get('states')?.value)
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', this.filterForm.get('states')?.value);
        })
      )
      .subscribe(data => {
        if (data.data) {
          allCities = allCities.concat(data.data);
        }
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }

  loadBrands() {
    this.oemService.getBrandsList().subscribe({
      next: (response) => {
        this.brands = response.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.allCountriesSymbol = Array.from(
          this.brands.reduce((countrySymbolsMap, b: any) => {
            let countrySymbol = {
              currencySymbol: '',
              currency: '',
              countryName: '',
            };
            const countryMatch = this.allCountriesSymbol.find((c: any) => c.countryName === b.country);
            if (countryMatch) {
              countrySymbol.currencySymbol = countryMatch.currencySymbol;
              countrySymbol.currency = countryMatch.currency;
              countrySymbol.countryName = countryMatch.countryName;
              countrySymbolsMap.set(b.country, countrySymbol);
            }

            return countrySymbolsMap;
          }, new Map())
            .values()
        );

        this.allCountriesSymbol = this.allCountriesSymbol.filter((symbol: any) => symbol.currencySymbol != null && symbol.currencySymbol !== '');
        this.allCountriesSymbol = this.allCountriesSymbol.filter((item: any) => item !== undefined);
        this.filteredBrands = this.brands;
        this.yearInMarkets = [...new Set( this.brands
          .map((item: { year: any; }) => item.year)
          .filter((year: any) => year != null && year !== '' && year !== 0)
        )];
      },
      error: (error) => {
      }
    });
  }
  

  loadcategories() {
    this.categoryService.getLastNodeCategory().subscribe(data => {
      if (data && data.data && data.data.length > 0) {
        this.categories = data.data;
        if(!this.filteredCategories){
          this.filteredCategories = data.data;
        }
      }
    }, error => {
    });
  }

  resetFilters() {
    const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = ''; // Clear the input field after selection
    }
    this.filterForm.reset();
    this.applyFilter();
  }

  add(controlName: string, event: any, isSuggestion: boolean = false): void {
    if (isSuggestion) {
      const value = event.value;
      this.searchSuggestions = [];
      if ((value || '').trim()) {
        const currentValues = this.filterForm.get(controlName)?.value || [];
        this.filterForm.get(controlName)?.setValue([...currentValues, value.trim()]);
      }
    }
  }
  searchSuggestions: any[] = [];
  isSugestionOpen: boolean = false;
  debounceTimer: any;

  searchSuggestionDebounce(event: any) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() =>
      this.searchSuggestion(event),
      450);
  }

  searchSuggestion(event: any): void {
    const query = this.paramsSearch || event?.target?.value?.trim() || '';
    if (query) {
      this.oemService.searchSuggestion(query).subscribe({
        next: (response) => {
          this.searchSuggestions = response.data || [];
          this.isSugestionOpen = this.searchSuggestions.length > 0;
        },
        error: (error) => {
          this.searchSuggestions = [];
          this.isSugestionOpen = false;
        }
      })
    }
  }

  selectedSuggestion(suggestion: any): void {
    if (suggestion?.name) {
      this.add('keywords', { value: suggestion.name }, true);
      const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ''; // Clear the input field after selection
      }
      this.searchSuggestions = [];
      this.isSugestionOpen = false;
    }
  }
  remove(controlName: string, item: string | number): void {
    const control = this.filterForm.get(controlName);
    if (control) {
      let currentValues = control.value || [];
      const index = currentValues.indexOf(item);

      if (index >= 0) {
        currentValues.splice(index, 1);
        control.setValue(currentValues);
      }
      // Reset the control if there are no remaining items
      if (currentValues.length === 0) {
        control.reset();
      }
      // Apply the filter after updating the values
      this.applyFilter();
    }
  }

  onOptionSelected(event: any, filterType: string): void {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'continent':
      case 'country':
        currentValues = this.filterForm.get('countries')?.value || [];
        if (!currentValues.includes(event.option.value.countryName)) {
          this.filterForm.get('countries')?.setValue([...currentValues, event.option.value.countryName]);
          this.loadStates();
        }
        const countryName = event.option.value.countryName;
        this.allCountriesSymbol.forEach((country: any) => {
          if (country?.countryName === countryName) {
            this.currencySymbol = country?.currencySymbol
            return;
          }
        })
        this.countryControl.reset();
        break;

      case 'state':
        currentValues = this.filterForm.get('states')?.value || [];
        if (!currentValues.includes(event.option.value.stateName)) {
          this.filterForm.get('states')?.setValue([...currentValues, event.option.value.stateName]);
        }
        this.stateControl.reset();
        break;

      case 'city':
        currentValues = this.filterForm.get('cities')?.value || [];
        if (!currentValues.includes(event.option.value.cityName)) {
          this.filterForm.get('cities')?.setValue([...currentValues, event.option.value.cityName]);
        }
        this.cityControl.reset();
        break;

      case 'brand':
        currentValues = this.filterForm.get('brands')?.value || [];
        if (!currentValues.includes(event.option.value.name)) {
          this.filterForm.get('brands')?.setValue([...currentValues, event.option.value.name]);
        }
        this.brandControl.reset();
        break;

      case 'category':
        currentValues = this.filterForm.get('categories')?.value || [];
        if (!currentValues.includes(event.option.value)) {
          this.filterForm.get('categories')?.setValue([...currentValues, event.option.value]);
        }
        this.categoryControl.reset();
        break;

      case 'symbol':
        const selectedSymbol = event.option.value;  // This is the selected symbol as a string
        currentValues = this.filterForm.get('currencySymbol')?.value || [];
        if (!currentValues.includes(selectedSymbol)) {
          this.filterForm.get('currencySymbol')?.setValue([...currentValues, selectedSymbol]);
        }
        this.currencySymbolControl.reset();
        break;

      case 'range':
        const selectedRange = event.option.value;
        currentValues = this.filterForm.get('amountRange')?.value || [];
        if (!currentValues.some(range => range.label === selectedRange.label)) {
          // Add the whole object (including label) to the selected array
          this.filterForm.get('amountRange')?.setValue([...currentValues, selectedRange]);
        }
        this.amountRangeControl.reset();
        break;

      default:
        break;
    }
    this.applyFilter();
  }
  displayLabel(option: { label: string; min: number; max: number }): string {
    return option ? option.label : '';
  }
  displaySymbol(option: { symbol: string }): string {
    return option ? option.symbol : '';  // Return only the symbol part of the object
  }

}